import { compact, uniq } from "lodash";
import * as React from "react";

import useListSyllabusMoves from "../../hooks/syllabi/useListSyllabusMoves";
import useUpdateSyllabus from "../../hooks/syllabi/useUpdateSyllabus";
import { Syllabus, Move } from "../../types";

import Modal from "../common/Modal";
import Button from "../common/PressableButton";
import Text from "../common/Text";
import MoveComponents from "../move";

export interface AddMoveToSyllabusProps {
  syllabusId: Syllabus["id"];
}

function AddMoveToSyllabus({ syllabusId }: AddMoveToSyllabusProps) {
  const [isVisible, setIsVisible] = React.useState(false);
  const { mutate: updateSyllabus, isLoading } = useUpdateSyllabus(() => {
    setIsVisible(false);
  });
  const { data: moves } = useListSyllabusMoves(syllabusId);
  const moveIds = React.useMemo(
    () => moves?.map((move) => move.id) || [],
    [moves]
  );
  const buttonTitle = "Add Move";
  const modalTitle = "Add Move";
  const [moveId, setMoveId] = React.useState<Move["id"]>();

  React.useEffect(() => {
    if (!isVisible) {
      setMoveId(undefined);
    }
  }, [isVisible]);

  const addMove = () => {
    if (moveId) {
      updateSyllabus({
        id: syllabusId,
        moves: uniq(compact([...moveIds, moveId])),
      });
    }
  };

  return (
    <>
      <Button
        title={buttonTitle}
        onPress={() => setIsVisible(true)}
        mode="contained"
      />

      <Modal
        onDismiss={() => setIsVisible(false)}
        isDismissable={!isLoading}
        title={modalTitle}
        isVisible={isVisible}
        primaryAction={
          <Button
            title={buttonTitle}
            onPress={() => {
              if (moveId) {
                addMove({ moveId, syllabusId });
              }
            }}
            disabled={isLoading}
            mode="contained"
          />
        }
        // secondaryAction={
        //   <Modal.DismissButton
        //     onPress={() => setIsVisible(false)}
        //     disabled={isLoading}
        //   />
        // }
        content={
          <Modal.Content>
            <Text.Label>Move</Text.Label>
            <MoveComponents.Input
              value={moveId}
              onChange={(nextMoveId) => setMoveId(nextMoveId)}
              showMove={(move) => !moveIds.includes(move.id)}
            />
          </Modal.Content>
        }
      />
    </>
  );
}

export default AddMoveToSyllabus;
